var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        function equalHotHeight() {
            var h = 0;
            // $("#hot_offers .view .text .offerTitle")
            var textItems = $("#hot_offers .view .text");
            textItems.each(function () {
                var hh = $(this).height();
                if (hh > h) h = hh;
            });
            textItems.height(h);

            // h = 0;
            // $("#hot_offers .view .text").each(function () {
            //     var hh = $(this).height();
            //     if (hh > h) h = hh;
            // });
            // $("#hot_offers .view .text").height(h);
        }

        equalHotHeight();

        jQuery.expr.filters.offscreen = function (el) {
            var rect = el.getBoundingClientRect();
            return rect.x + rect.width < 0 || rect.y + rect.height < 0 || rect.x > window.innerWidth || rect.y > window.innerHeight;
        };

        var hotSlider = function () {
            function hotSlider(mode, code, params) {
                _classCallCheck(this, hotSlider);

                //Обработчики
                this.mode = mode;
                this.code = code;
                this.timer = null;
                this.$elem = $('mainSelector' in params ? params.mainSelector : '#hot_offers');
                this.$controls = this.$elem.find('.hot-offers-widget-controls');
                this.$elems = {
                    arrOffers: $('arrowSelector' in params ? params.arrowSelector : '.arr_offers'),
                    arrOffersLeft: $('leftArrowSelector' in params ? params.leftArrowSelector : '.arr_offers.left'),
                    arrOffersRight: $('rightArrowSelector' in params ? params.rightArrowSelector : '.arr_offers.right'),
                    offers: this.$elem.find('itemsSelector' in params ? params.itemsSelector : '.items'),
                    offerItems: [],
                    offersWrapper: this.$elem.find('.hot-offers-widget-list')
                };
                this.itemSelector = 'itemSelector' in params ? params.itemSelector : '.view';
                this.setOfferItems();

                this.element = this.$elem.find('.hotOffers');
                this.offset = this.element.offset();
                this.touchStartPos = 0;
                this.w = this.element.width(); //+2 (border)
                this.w_element = 'w_element' in params ? params.w_element : 305;
                this.delta = 'delta' in params ? params.delta : 14;
                this.mouseMoveHeight = 'mouseMoveHeight' in params ? params.mouseMoveHeight : 195;
                this.minX = null;
                this.chache = [];

                this.setMinX();
                this.handlers();

                this.renderControls();
            }

            _createClass(hotSlider, [{
                key: "setMinX",
                value: function setMinX() {
                    this.minX = -this.$elems.offerItems.length * this.w_element + this.w + this.delta;
                }
            }, {
                key: "setOfferItems",
                value: function setOfferItems() {
                    this.$elems.offerItems = this.$elems.offers.find(this.itemSelector);
                }
            }, {
                key: "insertHotOffers",
                value: function insertHotOffers(offersHtml) {
                    var that = this;
                    that.$elems.offers.fadeOut('fast', function () {
                        that.$elems.offers.empty().html(offersHtml).css('margin-left', '2px').fadeIn('fast', function () {
                            equalHotHeight();
                            that.setOfferItems();
                            that.setMinX();
                            that.renderControls();
                        });
                    });
                }
            }, {
                key: "getOffersData",
                value: function getOffersData(that, city_id, city_name) {
                    var $this = this;
                    $.get('/offer/slider-by-city.html?cityId=' + city_id, function (data) {
                        if (data !== '') {
                            that.insertHotOffers(data);
                            that.chache[city_id] = data;
                            $this.$elem.css({ 'overflow': 'hidden' });
                        } else {
                            $this.$elems.offers.empty().hide();
                            $this.$elem.css({ 'overflow': 'unset' });
                        }
                        that.setCityInSelect(city_id, city_name);
                    });
                }
            }, {
                key: "setCityInSelect",
                value: function setCityInSelect(cityId, cityName) {
                    var $city = $('.hot_fake_option[data-city="' + cityId + '"]');
                    if ($city.length > 0) {
                        $('.fake_select_text span').text(cityName);
                        $('.hot_fake_option_checked').removeClass('hot_fake_option_checked');
                        $city.addClass('hot_fake_option_checked');
                    }
                }
            }, {
                key: "renderControls",
                value: function renderControls() {
                    if (this.isMoveOfferAvailable()) {
                        this.$controls.removeClass('hidden');
                        this.$elems.offersWrapper.removeClass('fixed-offer');
                    } else {
                        this.$controls.addClass('hidden');
                        this.$elems.offersWrapper.addClass('fixed-offer');
                    }
                }

                /**
                 * Можно ли перемещать предложения, когда их мало, то не нужно
                 * @returns {boolean}
                 */

            }, {
                key: "isMoveOfferAvailable",
                value: function isMoveOfferAvailable() {
                    return this.$elem.find('.offer-item').length * 375 > document.documentElement.clientWidth;
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var that = this;
                    if (this.mode !== 'country') {
                        this.$elems.offers.mousemove(function (e) {
                            if (!that.isMoveOfferAvailable()) {
                                return;
                            }
                            that.offersMove(e);
                        }).mouseout(function () {
                            clearTimeout(that.timer);
                            that.$elems.arrOffers.removeClass('moves');
                        });

                        this.$elems.arrOffers.on('click', function () {
                            var dir = -1;
                            if ($(this).hasClass('right')) dir = 1;

                            var ml = Math.abs(parseFloat(that.$elems.offers.css('margin-left')));
                            var t = ml / that.w_element;
                            var cur = Math.ceil(t);
                            if (dir === -1) {
                                cur = Math.floor(t);
                            }
                            if (t == cur) {
                                cur += dir;
                            }

                            var newX = -1 * that.w_element * cur; //
                            if (newX == 0) {
                                newX = 2;
                            }
                            //console.debug(newX);
                            if (0 < newX) {
                                that.$elems.arrOffersLeft.addClass('disabled');
                                that.$elems.arrOffersRight.removeClass('disabled');
                            } else if (newX < that.minX) {
                                that.$elems.arrOffersRight.addClass('disabled');
                                that.$elems.arrOffersLeft.removeClass('disabled');
                            }

                            newX = newX > 1 ? 0 : newX < that.minX ? that.minX : newX;

                            if (newX < that.minX) newX = that.minX;

                            that.$elems.offers.animate({ marginLeft: newX + 'px' }); //4054
                            //offers.css('margin-left',newX+'px');
                            //newX = newX>1?0:(newX<that.minX?that.minX:newX);
                        });

                        that.element.bind('touchstart', function (event) {
                            var e = event.originalEvent;
                            that.touchStart(e.touches[0]);
                        });
                        that.element.bind('touchmove', function (event) {
                            var e = event.originalEvent;
                            that.touchMove(e.touches[0]);
                        });
                        that.element.bind('touchend', function (event) {
                            that.touchEnd(event.originalEvent.touches[0]);
                        });
                    }

                    $('div.hot_fake_select').on('click', 'div.fake_select_text', function () {
                        $('.hot_fake_options').toggle();
                    });

                    $('div.hot_fake_options').on('click', 'div.hot_fake_option', function () {
                        $('div.hot_fake_options').hide();
                        if ($(this).hasClass('hot_fake_option_checked')) {
                            return;
                        }
                        var city_id = $(this).data('city');
                        var city_name = $(this).text();
                        if (that.chache[city_id]) {
                            that.insertHotOffers(that.chache[city_id]);
                            that.setCityInSelect(city_id, city_name);
                        } else {
                            that.getOffersData(that, city_id, city_name);
                        }
                    });

                    $("body").on('click', function (e) {
                        if ($(e.target).closest(".hot_fake_select").length === 0) {
                            $(".hot_fake_options").hide();
                        }
                    });

                    $(window).on('onLocation', function (event, city) {
                        /** @type {window.CityItem} city */
                        if (!city.id) {
                            // если города нет в списке
                            return;
                        }

                        // если город не имеет собстенных горящих, ничего не делаем
                        if ($("div.hot_fake_options .hot_fake_option[data-city=" + city.id + "]").length === 0) {
                            return;
                        }

                        that.getOffersData(that, city.id, city.name);
                    });
                }
            }, {
                key: "touchEnd",
                value: function touchEnd() {
                    clearTimeout(this.timer);
                    this.$elems.arrOffers.removeClass('moves');
                }
            }, {
                key: "touchMove",
                value: function touchMove(event) {
                    clearTimeout(this.timer);
                    //Область дозволенная
                    var x = -1 * (this.touchStartPos - event.pageX);
                    this.touchStartPos = event.pageX;
                    var ml = parseFloat(this.$elems.offers.css('margin-left')); //текущее значение отступа
                    var newX = ml + x; //новый отступ

                    this.$elems.arrOffers.removeClass('moves disabled');
                    if (0 < newX) {
                        newX = 0;
                        this.$elems.arrOffersLeft.addClass('disabled');
                    } else if (newX < this.minX) {
                        newX = this.minX;
                        this.$elems.arrOffersRight.addClass('disabled');
                    } else {
                        if (0 > x) {
                            //вправо
                            this.$elems.arrOffersRight.addClass('moves');
                        } else if (0 < x) {
                            //влево
                            this.$elems.arrOffersLeft.addClass('moves');
                        }
                    }
                    this.$elems.offers.css('margin-left', newX + 'px');
                }
            }, {
                key: "touchStart",
                value: function touchStart(event) {
                    clearTimeout(this.timer);
                    this.touchStartPos = event.pageX;
                }
            }, {
                key: "offersMove",
                value: function offersMove(e) {
                    var that = this;
                    clearTimeout(this.timer);
                    var hotOffset = this.$elem.offset();
                    if (e.pageY - hotOffset.top > this.mouseMoveHeight) {
                        return;
                    }
                    var mx = e.pageX - hotOffset.left;
                    var speed = (this.w / 2 - mx) / 50;
                    if (speed > -0.5 && speed < 0.5) speed = 0;
                    var ml = parseFloat(this.$elems.offers.css('margin-left')),
                        newX = ml + speed;
                    this.$elems.arrOffers.removeClass('moves disabled');
                    if (0 < newX) {
                        newX = 0;
                        this.$elems.arrOffersLeft.addClass('disabled');
                    } else if (newX < this.minX) {
                        newX = this.minX;
                        this.$elems.arrOffersRight.addClass('disabled');
                    } else {
                        if (-0.5 > speed) {
                            //вправо
                            this.$elems.arrOffersRight.addClass('moves');
                        } else if (0.5 < speed) {
                            //влево
                            this.$elems.arrOffersLeft.addClass('moves');
                        }
                    }

                    this.$elems.offers.css('margin-left', newX + 'px');
                    this.timer = setTimeout(function () {
                        that.offersMove(e);
                    }, 10);
                }
            }]);

            return hotSlider;
        }();

        window.hotSlider = hotSlider;
    }, {}] }, {}, [1]);